
const translations = {
    en: {
        DEFAULT_MSG: 'translation was not found',
        LOGIN_HEAD: 'Login',
        // Add more translations here
    },
    he: {
        DEFAULT_MSG: 'תרגום לא נמצא',
        LOGIN_HEAD: 'התחברות',
        USERNAME_LOGIN: ' שם משתמש וסיסמא',
        PHONE_NUMBER_LOGIN: 'מספר סלולר',
        LOGIN_BTN: 'התחבר',
        USERNAME: 'שם משתמש',
        PHONE_NUMBER: 'מספר סלולר',
        CODE_SEND_TO: 'קוד נשלח ל',
        LOG_OUT: 'יציאה',
        AREAS: 'איזורים',
        GENERAL_SETT: 'כללי',
        ENTER_CAPTCHA: 'הכנס קוד',
        PASS: 'סיסמא',
        WELCOME: 'ברוכים הבאים,',
        TO_BUS: 'לעסק:',
        LOADING: 'בטעינה',
        ALL: 'הכל',
        VERIFY: 'בדיקת קוד',
        SEND_CODE: 'שליחת סמס',
        F_OR_L_NAME: 'שם פרטי או משפחה',
        REFRESH: 'רענון קוד',
        ENTER_CODE_SMS: 'הכנס קוד SMS',
        LOGIN_ERROR: 'התחברות נכשלה, טעות בסיסמא ,משתמש או קוד ',
        FAIL_LOGIN_PHONE: 'שגיאה בשרת הSMS, נסה להתחבר עם סיסמא או פנה למערכת',
        SETTINGS: "הגדרות",
        HOLIDAYS: "חגים ומועדים",
        BUSINESS_HOURS: "שעות פעילות העסק",
        BUSINESS_DAYS: "ימי פעילות העסק",
        BLOCKED_DATES: "מועדים חסומים",
        GENERAL: "כללי",
        MESSAGE_MANAGEMENT: "ניהול הודעות",
        AREA_MANAGMENT:'ניהול אזורים',
        MAIN_AREA:'איזור ראשי',
        APPROVE:'אישור',
        CANCEL:'ביטול',
        NAME_TAKEN_OR_TOO_SHORT:'שם תפוס או קצר מדי',
        U_SURE:'האם את\\ה בטוח\\ה?',
        HAS_SUB:'קיימים תתי איזורים :',
        DEL:'מחק',
        SEC_AREA_TO:'איזור משני של',
        ADD_AREA:'הוסף איזור',
        SAVE_DETAILS:'שמור פרטים',
        NAME_TAKEN:'שם תפוס כבר',
        ISPERMANENT:'האם נעול?',
        ACTIONS:'פעולות',
        ID:'סידורי',
        STATUS:'סטטוס',
        BUSINESSID:'מספר עסק',
        TABLENAME:'שם שולחן',
        SHAPETYPE:'צורה',
        DEFAULTXSIZE:' ברירת מחדל מיקום X',
        DEFAULTYSIZE:'  ברירת מחדל מיקום Y',
        XPOSITION:'מיקום X',
        YPOSITION:'מיקום Y',
        DINERSNUMBER:'מספר סועדים',
        TABLEAREAID:'איזור',
        ACTIVE:'פעיל',
        YES:'כן',
        ADD_TABLE:'הוסף שולחן',
        NO:'לא',
        PICK_AREA:'בחר איזור',
        PICK_SHAPE:'בחר צורה',
        BUSINESS_SETTINGS:'הגדרות העסק',
        PERMISSIONS:'הרשאות',
        SEAT_MANAGEMENT:'ניהול הזמנות',
        BUSINESS_OPEN_TIME:'ימים ושעות פעילות',
        BUEIS_Code: 'קוד חברה',
        ASK_MANAGER: 'בקש קישור או שיוך מהמנהל',
        REGISTER_HEAD: 'משתמש חדש - הרשמה',
        REGISTER: 'הירשם',
        FIRST_NAME: 'שם פרטי',
        LAST_NAME: 'שם משפחה',
        EMAIL: 'דואר אלקטרוני',
        REGISTER_BTN: 'הירשם',
        BACK: 'חזור',
        RESET: 'איפוס',
        NO_USER: 'אין משתמש?',
        APPROVED_CODE: 'קוד תקין',
        DECLINED_CODE: 'קוד לא תקין',
        ACC_EXIST: 'משתמש קיים כבר במערכת',
        SEND_CODE_AGAIN: 'לא קיבלתי קוד,שלח שוב',
        NEW_PASS: 'סיסמא חדשה',
        SEND: 'שלח',
        OLD_PASS: 'סיסמא ישנה',
        RESET_PASS: 'איפוס סיסמא',
        FROGET_PASS: 'איפוס סיסמא',
        EDIT_USER: 'עריכת משתמש',
        MY_BUES: 'עסקים ובקשות',
        // Add more translations here
    },
};

export default translations;